// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"4b63cecc","219":"75c28455","378":"a03eb601","453":"53bfa5b2","594":"1fdb4731","610":"b0607d2a","864":"4c703b29","983":"88133eec"}[chunkId] + ".chunk.js";
};